module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_6000.36f59c33.png";